// extracted by mini-css-extract-plugin
export var quillEditor = "_ov-1";
export var variable = "_ov-0";